import { mount, shallow, ShallowWrapper } from 'enzyme';
import * as React from 'react';
import { TAssessRiskProfile } from '../models/assessRiskProfile.model';
import {
  InvestmentReturnComponent,
  TInvestmentReturnProps,
} from './investmentReturn';
import { object } from '@storybook/addon-knobs';

// import RiskProfile, { TRiskProfileProps } from "../RiskProfile.component";

describe('Investment Return Component with props', () => {
  let testInvestmentReturnProps: TInvestmentReturnProps;

  // let testRiskProfileProps: TRiskProfileProps;
  let mountedRiskProfileWrapper;
  let height = 50;
  let investmentAmount = 10000;
  let investmentRangeData: TAssessRiskProfile[] = [];

  investmentRangeData.push({
    gainLoss: {
      gainPercent: 43,
      longTermAveragePercent: 20,
      lossPercent: 20,
    },
    id: 0,
  });

  investmentRangeData.push({
    gainLoss: {
      gainPercent: 52,
      longTermAveragePercent: 20,
      lossPercent: 25,
    },
    id: 1,
  });

  investmentRangeData.push({
    gainLoss: {
      gainPercent: 56,
      longTermAveragePercent: 20,
      lossPercent: 30,
    },
    id: 2,
  });

  investmentRangeData.push({
    gainLoss: {
      gainPercent: 62,
      longTermAveragePercent: 20,
      lossPercent: 35,
    },
    id: 3,
  });

  investmentRangeData.push({
    gainLoss: {
      gainPercent: 72,
      longTermAveragePercent: 20,
      lossPercent: 37,
    },
    id: 4,
  });

  investmentRangeData.push({
    gainLoss: {
      gainPercent: 82,
      longTermAveragePercent: 20,
      lossPercent: 39,
    },
    id: 4,
  });

  let choices = [
    {
      choiceId: 1,
      sequence: 1,
      choice: 'Low',
      score: 0.33333298563957214,
      selected: true,
    },
    {
      choiceId: 2,
      sequence: 2,
      choice: 'Moderate',
      score: 0.6666659712791443,
      selected: false,
    },
    {
      choiceId: 3,
      sequence: 3,
      choice: 'High',
      score: 0.9999989867210388,
      selected: false,
    },
    {
      choiceId: 4,
      sequence: 4,
      choice: 'Very High',
      score: 1.3333319425582886,
      selected: false,
    },
    {
      choiceId: 5,
      sequence: 5,
      choice: 'Very High',
      score: 1.3333319425582886,
      selected: false,
    },
    {
      choiceId: 6,
      sequence: 6,
      choice: 'Very High',
      score: 1.3333319425582886,
      selected: false,
    },
  ];

  beforeEach(() => {
    testInvestmentReturnProps = {
      invesetmentRangeData: investmentRangeData,
      barRangeSelected: 0,
      investmentAmount: 50000,
      choices: choices,
      onNextButtonClick: jest.fn(),
      /** Back button click event handler */
      onBackButtonClick: jest.fn(),
      /** Skip button click event handler */
      onSkipButtonClick: jest.fn(),
    };

    mountedRiskProfileWrapper = mount(
      <InvestmentReturnComponent {...testInvestmentReturnProps} />,
    );
  });

  it('renders correctly', () => {
    expect(mountedRiskProfileWrapper).not.toBeUndefined();
  });

  test('convertStringtoDollarString', () => {
    mountedRiskProfileWrapper
      .find('.bar')
      .first()
      .simulate('click');

    mountedRiskProfileWrapper.update();

    expect(mountedRiskProfileWrapper.state('barRangeSelected')).toBe(1);
  });
});
